export default __webpack_public_path__ + "static/media/cp_geo_eg.0621dac2.svg";